import classNames from 'classnames';

export const defaultYSpace = 32;
export const defaultXSpace = 6;

export function H1({ children, className, ...props }) {
    return (
        <h1 className={classNames('text-3xl font-bold tracking-tight md:text-4xl xl:text-6xl', className)} {...props}>
            {children}
        </h1>
    );
}

export function H1Sub({ children, className, ...props }) {
    return (
        <span className={classNames('text-2xl font-bold tracking-tight md:text-3xl xl:text-5xl', className)} {...props}>
            {children}
        </span>
    );
}

export function H2({ children, className, ...props }) {
    return (
        <h2 className={classNames('text-2xl font-bold tracking-tight md:text-3xl xl:text-4xl', className)} {...props}>
            {children}
        </h2>
    );
}

export function Container({ children, className, ...props }) {
    return (
        <div className={classNames(`container px-${defaultXSpace} mx-auto`, className)} {...props}>
            {children}
        </div>
    );
}

export function Wrapper({ children, className, ...props }) {
    return (
        <section className={classNames(`py-${defaultYSpace}`, className)} {...props}>
            {children}
        </section>
    );
}
